import { useLoggedInUser } from "@/components/providers/ApiProvider/hooks";
import { useOnboardingBannerMutations } from "./useOnboardingBannerMutations";

/**
 * Custom hook that provides a function to collapse the onboarding banner
 * after a successful upload, if the banner is currently expanded.
 *
 * @returns A function that should be called in the upload success callback
 */
export function useCollapseBannerOnUpload() {
  const { data: user } = useLoggedInUser();
  const { collapseMutation } = useOnboardingBannerMutations();

  const collapseBannerIfExpanded = () => {
    // Check if banner is expanded (not dismissed and not collapsed)
    const isBannerExpanded =
      !user?.profile?.audiolabBannerDismissed &&
      !user?.profile?.audiolabBannerCollapsed;

    if (isBannerExpanded) {
      collapseMutation.mutate({
        data: { audiolabBannerCollapsed: true },
      });
    }
  };

  return collapseBannerIfExpanded;
}
